import React from 'react';
import { Box, Typography, TextField, MenuItem, Button } from '@mui/material';
import { FilterList, Clear } from '@mui/icons-material';
import { prefectures } from '../../data/prefectures';

interface Filters {
  prefecture: string;
  workStyle: string;
  competitionPriority: string;
  strength: string;
}

interface Props {
  filters: Filters;
  onChange: (filters: Filters) => void;
  onSearch: () => void;
  onClear: () => void;
}

const workStyleOptions = [
  'フルタイム勤務',
  '時短勤務・フレックス',
  'リモートワーク中心',
  'パートタイム・業務委託',
];

const competitionPriorityOptions = [
  '競技が最優先（仕事は副次的）',
  '競技優先だが、仕事にも真剣に取り組みたい',
  '仕事と競技を同等に両立したい',
  '仕事優先で、余暇に競技を続けたい',
];

const strengthOptions = [
  'チームワーク力', '目標達成力', 'メンタルタフネス', '自己成長意欲', 'リーダーシップ',
  'コミュニケーション力', 'プレゼンテーション力', '交渉力', '傾聴力',
  '問題発見力', '分析力', '計画力', '実行力',
];

const SearchFilters: React.FC<Props> = ({ filters, onChange, onSearch, onClear }) => {
  const update = (key: keyof Filters, value: string) => {
    onChange({ ...filters, [key]: value });
  };

  return (
    <Box sx={{ p: 3, bgcolor: 'white', borderRadius: 2, border: '1px solid #e0e0e0' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <FilterList sx={{ mr: 1, color: '#0066cc' }} />
        <Typography variant="h6" sx={{ fontWeight: 600 }}>検索フィルタ</Typography>
      </Box>

      <TextField
        label="都道府県"
        select
        fullWidth
        size="small"
        value={filters.prefecture}
        onChange={(e) => update('prefecture', e.target.value)}
        sx={{ mb: 2 }}
      >
        <MenuItem value="">すべて</MenuItem>
        {prefectures.map((p) => <MenuItem key={p} value={p}>{p}</MenuItem>)}
      </TextField>

      <TextField
        label="希望する働き方"
        select
        fullWidth
        size="small"
        value={filters.workStyle}
        onChange={(e) => update('workStyle', e.target.value)}
        sx={{ mb: 2 }}
      >
        <MenuItem value="">すべて</MenuItem>
        {workStyleOptions.map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
      </TextField>

      <TextField
        label="競技優先度"
        select
        fullWidth
        size="small"
        value={filters.competitionPriority}
        onChange={(e) => update('competitionPriority', e.target.value)}
        sx={{ mb: 2 }}
      >
        <MenuItem value="">すべて</MenuItem>
        {competitionPriorityOptions.map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
      </TextField>

      <TextField
        label="強み"
        select
        fullWidth
        size="small"
        value={filters.strength}
        onChange={(e) => update('strength', e.target.value)}
        sx={{ mb: 3 }}
      >
        <MenuItem value="">すべて</MenuItem>
        {strengthOptions.map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
      </TextField>

      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button variant="contained" onClick={onSearch} fullWidth>
          検索
        </Button>
        <Button variant="outlined" onClick={onClear} startIcon={<Clear />}>
          クリア
        </Button>
      </Box>
    </Box>
  );
};

export default SearchFilters;
